// src/store/apis/salesReturnApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/* ------------------------------ helpers ------------------------------ */
const key = (x) => String(x ?? "");
const pickData = (res) => res?.data ?? res?.entry ?? res;

/* --------------------------------------------------------------------- */

export const salesReturnApi = createApi({
  reducerPath: "salesReturnApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["SR"],
  endpoints: (builder) => ({
    /* --------------------------- SR LIST (history) --------------------------- */
    // useGetSalesReturnsQuery({ invoiceId, invoiceCode, customerId, branchId, fromDate, toDate, page, limit })
    getSalesReturns: builder.query({
      query: (args = {}) => {
        const {
          page = 1,
          limit = 10,
          invoiceId = "",
          invoiceCode = "",
          customerId = "",
          branchId = "",
          fromDate = "",
          toDate = "",
        } = args || {};

        const params = { page, limit };

        if (invoiceId) params.invoiceId = invoiceId;
        if (invoiceCode) params.invoiceCode = invoiceCode;
        if (customerId) params.customerId = customerId;
        if (branchId) params.branchId = branchId;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;

        return { url: "/sales-return", method: "GET", params };
      },
      // result shape: { data: [...], pagination: {...} }
      providesTags: (result) => {
        const rows = pickData(result);
        if (Array.isArray(rows)) {
          return [
            ...rows.map((sr) => ({ type: "SR", id: key(sr._id) })),
            { type: "SR", id: "LIST" },
          ];
        }
        if (Array.isArray(result?.data)) {
          return [
            ...result.data.map((sr) => ({ type: "SR", id: key(sr._id) })),
            { type: "SR", id: "LIST" },
          ];
        }
        return [{ type: "SR", id: "LIST" }];
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const a = queryArgs || {};
        return [
          endpointName,
          a.page || 1,
          a.limit || 10,
          a.invoiceId || "",
          a.invoiceCode || "",
          a.customerId || "",
          a.branchId || "",
          a.fromDate || "",
          a.toDate || "",
        ].join("|");
      },
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: false,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    }),

    /* ----------------------------- SR DETAIL ---------------------------- */
    // useGetSalesReturnByIdQuery(id)
    getSalesReturnById: builder.query({
      query: (id) => `/sales-return/${id}`,
      providesTags: (_res, _err, id) => [{ type: "SR", id: key(id) }],
    }),

    /* ---------------------------- CREATE SR ---------------------------- */
    // useAddSalesReturnMutation()
    // payload = same body as createSalesReturn controller expects
    addSalesReturn: builder.mutation({
      query: (payload) => ({
        url: "/sales-return",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "SR", id: "LIST" }],
    }),

    /* ------------------------- RESEND SR SMS --------------------------- */
    // useResendSalesReturnSmsMutation()
    // call: resendSalesReturnSms(id)
    resendSalesReturnSms: builder.mutation({
      query: (id) => ({
        url: `/sales-return/${id}/sms-resend`,
        method: "POST",
      }),
      // list change nahi hota, but detail ko invalidate kar sakte hain future me
      invalidatesTags: (_res, _err, id) => [
        { type: "SR", id: "LIST" },
        { type: "SR", id: key(id) },
      ],
    }),
  }),
});

/* ----------------------------- hooks ----------------------------- */
export const {
  useGetSalesReturnsQuery,
  useGetSalesReturnByIdQuery,
  useAddSalesReturnMutation,
  useResendSalesReturnSmsMutation,
} = salesReturnApi;

export default salesReturnApi;
